module.exports = __webpack_public_path__ + "static/media/person.ea0f4772.svg";